export const getDisplayName = url => {
  return url
    .replace(/https:\/\//, "")
    .replace(/http:\/\//, "")
    .replace(/www./, "")
}
